
//language selector
$('.js-localization-selector-wrapper').click(function(e){
  e.preventDefault();
  let $modal_wrapper = $(this).find('.localization-form-modal-wrapper')
  if(!$modal_wrapper.hasClass('open')){
    
    $(document).on("click.language-selector-wrapper", function (event) {
      let $modal = $('.localization-form-modal-wrapper');
      if ($modal.hasClass("open") && !$(event.target).closest(".localization-form-modal-container").length) {
        handleLocalizationModalClose();
      }
    });
    $modal_wrapper.addClass('open');
    $(this).find('[role="button"]').attr('aria-expanded', 'true');
    e.stopPropagation();
    e.preventDefault();
  }
})

// Keyboard activation for the role="button" localization triggers (span/div don't fire click on keys)
$('.js-localization-selector-wrapper [role="button"]').on('keydown', function (e) {
  if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar' || e.which === 13 || e.which === 32) {
    e.preventDefault();
    $(this).closest('.js-localization-selector-wrapper').trigger('click');
  }
});

// Escape closes an open localization modal
$(document).on('keydown.language-selector-wrapper-esc', function (e) {
  if ((e.key === 'Escape' || e.which === 27) && $('.localization-form-modal-wrapper.open').length) {
    handleLocalizationModalClose();
  }
});

$('.js-localization-form-modal-close').click(function(e){
  e.preventDefault();
  e.stopPropagation();
  handleLocalizationModalClose();

})

function handleLocalizationModalClose(){

  $(document).off('.language-selector-wrapper');
  $('.localization-form-modal-wrapper').removeClass('open');
  $('.js-localization-selector-wrapper [role="button"]').attr('aria-expanded', 'false');
}


$('[name="localization-country"],[name="localization-language"]').change(function(e){
  let $form = $(this).parents('#localization_form');
  let locale = $form.find('.modal_locale_code');
  let country = $form.find('.modal_country_code');

  country.val($form.find('[name="localization-country"]').val());
  locale.val($form.find('[name="localization-language"]').val());
  //$form.submit();
})

$('.js-localization-form-submit').click(function(e){
  //e.preventDefault();
  let $form = $(this).parents('#localization_form');
  $form.trigger( "submit" );
  $form.submit();

})